import { useContext } from 'react';
import {
  createConnection,
  updateConnection,
  deleteConnection,
} from '../api/edgeOperations';
import AuthContext from '../context/AuthContext';

const normalizeEdge = (edge) => ({
  id: edge.id,
  label: edge.label,
  source: edge.source_node,
  target: edge.target_node,
});

export function useLinkMode({
  linkedNodes,
  setLinkedNodes,
  selectedEdge,
  setSelectedEdge,
  popupValue,
  setPopupValue,
  setPopupNodeId,
  setEdges,
}) {
  const { authFetch } = useContext(AuthContext);

  const resetLinkMode = () => {
    setLinkedNodes([]);
    setPopupNodeId(null);
    setPopupValue('');
    setSelectedEdge(null);
  };

  const updateExistingEdge = async (label) => {
    const updatedEdge = await updateConnection(authFetch, {
      id: selectedEdge.id,
      label,
    });

    const normalized = normalizeEdge(updatedEdge);

    setEdges((prev) =>
      prev.map((e) => (e.id === normalized.id ? normalized : e)),
    );
  };

  const createNewEdge = async (label) => {
    if (linkedNodes.length !== 2 || linkedNodes[0].id === linkedNodes[1].id) {
      return;
    }

    const newEdge = await createConnection(authFetch, {
      label,
      source_node: linkedNodes[0].id,
      target_node: linkedNodes[1].id,
    });

    setEdges((prev) => [
      ...prev,
      {
        id: newEdge.id,
        source: linkedNodes[0].id,
        target: linkedNodes[1].id,
        label,
      },
    ]);
  };

  const commitLink = async () => {
    const label = popupValue.trim();
    if (!label) return;

    try {
      if (selectedEdge) {
        await updateExistingEdge(label);
      } else {
        await createNewEdge(label);
      }

      resetLinkMode();
    } catch (err) {
      console.error('Link mode error:', err);
    }
  };

  const deleteLink = async () => {
    if (!selectedEdge) return;

    try {
      await deleteConnection(authFetch, { id: selectedEdge.id });

      setEdges((prev) => prev.filter((e) => e.id !== selectedEdge.id));

      resetLinkMode();
    } catch (err) {
      console.error('Failed to delete link:', err);
    }
  };

  return {
    commitLink,
    deleteLink,
    resetLinkMode,
  };
}
